/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetElaReadingLevelsR200ResponseInnerStarFromJSON, GetElaReadingLevelsR200ResponseInnerStarToJSON, } from './GetElaReadingLevelsR200ResponseInnerStar';
import { GetElaReadingLevelsR200ResponseInnerCurrentExtraFromJSON, GetElaReadingLevelsR200ResponseInnerCurrentExtraToJSON, } from './GetElaReadingLevelsR200ResponseInnerCurrentExtra';
/**
 * @export
 */
export const GetElaReadingLevelsR200ResponseInnerCurrentLevelEnum = {
    Er: 'ER',
    _1A: '1A',
    _1B: '1B',
    _1C: '1C',
    _2A: '2A',
    _2B: '2B',
    _2C: '2C',
    _3A: '3A',
    _3B: '3B',
    _3C: '3C',
    _4A: '4A',
    _4B: '4B',
    _4C: '4C',
    _5A: '5A',
    _5B: '5B',
    _5C: '5C',
    _6A: '6A',
    _6B: '6B',
    _6C: '6C',
    _7A: '7A',
    _7B: '7B',
    _7C: '7C',
    _8A: '8A',
    _8B: '8B',
    _8C: '8C',
    _9A: '9A',
    _9B: '9B',
    _9C: '9C',
    _10A: '10A',
    _10B: '10B',
    _10C: '10C',
    _11A: '11A',
    _11B: '11B',
    _11C: '11C',
    _12A: '12A',
    _12B: '12B',
    _12C: '12C'
};
/**
 * @export
 */
export const GetElaReadingLevelsR200ResponseInnerCurrentSourceEnum = {
    Map: 'map',
    Star: 'star',
    Manual: 'manual',
    FastBridge: 'fast_bridge'
};
/**
 * @export
 */
export const GetElaReadingLevelsR200ResponseInnerStartingLevelEnum = {
    Er: 'ER',
    _1A: '1A',
    _1B: '1B',
    _1C: '1C',
    _2A: '2A',
    _2B: '2B',
    _2C: '2C',
    _3A: '3A',
    _3B: '3B',
    _3C: '3C',
    _4A: '4A',
    _4B: '4B',
    _4C: '4C',
    _5A: '5A',
    _5B: '5B',
    _5C: '5C',
    _6A: '6A',
    _6B: '6B',
    _6C: '6C',
    _7A: '7A',
    _7B: '7B',
    _7C: '7C',
    _8A: '8A',
    _8B: '8B',
    _8C: '8C',
    _9A: '9A',
    _9B: '9B',
    _9C: '9C',
    _10A: '10A',
    _10B: '10B',
    _10C: '10C',
    _11A: '11A',
    _11B: '11B',
    _11C: '11C',
    _12A: '12A',
    _12B: '12B',
    _12C: '12C'
};
/**
 * @export
 */
export const GetElaReadingLevelsR200ResponseInnerStartingSourceEnum = {
    Map: 'map',
    Star: 'star',
    Manual: 'manual',
    FastBridge: 'fast_bridge'
};
/**
 * Check if a given object implements the GetElaReadingLevelsR200ResponseInner interface.
 */
export function instanceOfGetElaReadingLevelsR200ResponseInner(value) {
    if (!('studentId' in value) || value['studentId'] === undefined)
        return false;
    return true;
}
export function GetElaReadingLevelsR200ResponseInnerFromJSON(json) {
    return GetElaReadingLevelsR200ResponseInnerFromJSONTyped(json, false);
}
export function GetElaReadingLevelsR200ResponseInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentExtra': json['currentExtra'] == null ? undefined : GetElaReadingLevelsR200ResponseInnerCurrentExtraFromJSON(json['currentExtra']),
        'currentLevel': json['currentLevel'] == null ? undefined : json['currentLevel'],
        'currentSource': json['currentSource'] == null ? undefined : json['currentSource'],
        'star': json['star'] == null ? undefined : GetElaReadingLevelsR200ResponseInnerStarFromJSON(json['star']),
        'startingExtra': json['startingExtra'] == null ? undefined : GetElaReadingLevelsR200ResponseInnerCurrentExtraFromJSON(json['startingExtra']),
        'startingLevel': json['startingLevel'] == null ? undefined : json['startingLevel'],
        'startingSource': json['startingSource'] == null ? undefined : json['startingSource'],
        'studentId': json['studentId'],
    };
}
export function GetElaReadingLevelsR200ResponseInnerToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'currentExtra': GetElaReadingLevelsR200ResponseInnerCurrentExtraToJSON(value['currentExtra']),
        'currentLevel': value['currentLevel'],
        'currentSource': value['currentSource'],
        'star': GetElaReadingLevelsR200ResponseInnerStarToJSON(value['star']),
        'startingExtra': GetElaReadingLevelsR200ResponseInnerCurrentExtraToJSON(value['startingExtra']),
        'startingLevel': value['startingLevel'],
        'startingSource': value['startingSource'],
        'studentId': value['studentId'],
    };
}
